import type { Color } from "../types";

export interface PixelAccessor {
  /**
   * Returns pixel color at given coordinates.
   *
   * @param x
   * @param y
   */
  getPixelColor(x: number, y: number): Color;

  /**
   * Sets pixel color at given image coordinates.
   *
   * @param x
   * @param y
   * @param color
   */
  setPixelColor(x: number, y: number, color: Color): void;

  /**
   * Returns quantum range (max color channel value).
   */
  getQuantumRange(): number;
}

/**
 * Checks if given argument is PixelAccessor.
 *
 * @param obj
 */
export function isPixelAccessor(obj: unknown): obj is PixelAccessor {
  return (
    typeof obj === "object" &&
    obj !== null &&
    typeof (obj as Partial<PixelAccessor>).getPixelColor === "function" &&
    typeof (obj as Partial<PixelAccessor>).setPixelColor === "function" &&
    typeof (obj as Partial<PixelAccessor>).getQuantumRange === "function"
  );
}
